import {Typography} from "@mui/material";

export const ViewershipInfoContent = () => {

    return {
        title: 'Viewership',
        content: (
            <>
                <Typography paragraph>
                    Viewership records contain audience measurement data
                    that reflects how products are viewed across
                    distribution platforms and services.
                </Typography>

                <ul>
                    <li>
                        Viewership data may include metrics such as
                        views, viewed minutes, ratings, audience size,
                        or other measures of consumer engagement.
                    </li>

                    <li>
                        Viewership records are commonly associated with
                        Products, Platforms, Services, Territories,
                        Markets, and reporting periods.
                    </li>

                    <li>
                        Viewership information is often used to support
                        contractual calculations, reporting, forecasting,
                        performance analysis, and business intelligence.
                    </li>

                    <li>
                        Some contracts may use Viewership metrics directly
                        when calculating residuals, royalties,
                        participations, bonuses, or other obligations.
                    </li>

                    <li>
                        Historical Viewership data should be maintained
                        to support audits, recalculations, and trend
                        analysis over time.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Viewership records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Viewership data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Viewership record manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Viewership records.
                    </li>

                    <li>
                        Maintaining accurate Viewership data helps ensure
                        that audience-based calculations, reporting,
                        and contractual obligations are based on reliable
                        measures of product performance.
                    </li>
                </ul>
            </>
        )
    };

};







